<template>
    <div class="bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200">
        <div class="-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-nowrap px-4 py-5 sm:p-6">
            <div class="ml-4 mt-2">
                <h3 class="text-lg leading-6 font-medium text-gray-900">Photos</h3>
            </div>
        </div>
    
        <div class="px-4 py-5 sm:p-6">
            <div class="mb-8">
                <AssetImageUpload :organisation_id="ROUTE.params.organisation_id" :asset_id="vehicle_asset_id" field_id="vehicle-images-uploader" asset_type="vehicle" :media_types="['image']" :base_file_name="vehicle_data?.vrm" :hide_complete="true" />
            </div>
            <AssetImageManager  :asset_id="vehicle_asset_id" asset_type="vehicle" :media_types="['image']" />
        </div>
    
        <div class="px-4 py-4 sm:px-6 text-right">
            <Button type="button" width="w-auto" color="blue-outline" :onClick="VEHICLE.activatePrevStep">Back</Button>
            <Button type="button" width="w-auto" class="ml-2" :onClick="() => submitStep()">Next</Button>
        </div>
    </div>
</template>

<script>
import { useVehicleStore } from '@sto/vehicle.store'
import { useSystemStore } from '@sto/system.store'
import * as AssetService from '@ser/asset'
import { computed, onMounted, onBeforeMount, reactive, watch } from 'vue'
import LoadingIcon from '@ico/LoadingIcon.vue'
import { isValid, getPayload, poundsToPence } from '@lib/helpers'
import { useRoute } from 'vue-router'

import AssetImageUpload from '@par/asset/AssetImageUpload.vue'
import AssetImageManager from '@par/asset/AssetImageManager.vue'
import AssetImageManagerCompact from '@par/asset/AssetImageManagerCompact.vue'

export default {
    components: {
        LoadingIcon,
        AssetImageUpload,
        AssetImageManager,
        AssetImageManagerCompact
    },
    setup() {
        const VEHICLE = useVehicleStore()
        const ROUTE = useRoute()
        const SYSTEM_STORE = useSystemStore()

        const vehicle_id = computed(() => {
            return VEHICLE?.vehicle?.id || null
        })

        const vehicle_data = computed(() => {
            return VEHICLE?.vehicle || null
        })

        const vehicle_asset_id = computed(() => {
            return VEHICLE?.vehicle?.asset?.id || null
        })

        const submitStep = async () => {
            VEHICLE.activateNextStep()
        }

        onMounted(() => {
            SYSTEM_STORE.createInteraction('STEP_UPDATE', ROUTE.fullPath, 'Vehicle images step', null)
        })

        return {
            VEHICLE,
            ROUTE,
            submitStep,
            vehicle_asset_id,
            vehicle_data
        }
    }
}

</script>